"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette$backgr, _theme$palette$foregr, _theme$palette$foregr2, _theme$palette$backgr2, _theme$palette$foregr3, _theme$palette$foregr4, _theme$palette$backgr3;
  return {
    root: {
      alignItems: "center",
      background: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 || (_theme$palette$backgr = _theme$palette$backgr.header) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.pageTitle,
      boxShadow: theme.shadows[5],
      color: (_theme$palette$foregr = (_theme$palette$foregr2 = theme.palette.foreground) === null || _theme$palette$foregr2 === void 0 || (_theme$palette$foregr2 = _theme$palette$foregr2.header) === null || _theme$palette$foregr2 === void 0 ? void 0 : _theme$palette$foregr2.pageTitle) !== null && _theme$palette$foregr !== void 0 ? _theme$palette$foregr : theme.palette.getContrastText((_theme$palette$backgr2 = theme.palette.background) === null || _theme$palette$backgr2 === void 0 || (_theme$palette$backgr2 = _theme$palette$backgr2.header) === null || _theme$palette$backgr2 === void 0 ? void 0 : _theme$palette$backgr2.appBar),
      display: "flex",
      justifyContent: "center",
      minHeight: 55
    },
    fixed: {
      left: 0,
      position: "sticky",
      top: 0,
      width: "100%",
      zIndex: theme.zIndex.drawer
    },
    rootSaveTopAreaPadding: {
      minHeight: "calc(env(safe-area-inset-top) + 55px)",
      paddingTop: "env(safe-area-inset-top)"
    },
    headline: {
      overflow: "hidden",
      padding: theme.spacing(0, 2, 0, 2),
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    headlineClosePadding: {
      paddingLeft: theme.spacing(7),
      paddingRight: theme.spacing(7)
    },
    iconBack: {
      cursor: "pointer",
      left: theme.spacing(2),
      position: "absolute",
      [theme.breakpoints.up("sm")]: {
        left: theme.spacing(3)
      }
    },
    iconClose: {
      color: (_theme$palette$foregr3 = (_theme$palette$foregr4 = theme.palette.foreground) === null || _theme$palette$foregr4 === void 0 || (_theme$palette$foregr4 = _theme$palette$foregr4.header) === null || _theme$palette$foregr4 === void 0 ? void 0 : _theme$palette$foregr4.pageTitle) !== null && _theme$palette$foregr3 !== void 0 ? _theme$palette$foregr3 : theme.palette.getContrastText((_theme$palette$backgr3 = theme.palette.background) === null || _theme$palette$backgr3 === void 0 || (_theme$palette$backgr3 = _theme$palette$backgr3.header) === null || _theme$palette$backgr3 === void 0 ? void 0 : _theme$palette$backgr3.appBar),
      cursor: "pointer",
      position: "absolute",
      right: theme.spacing(2)
    }
  };
});
const PageNavigation = props => {
  const {
    title,
    fixed = false,
    saveTopAreaPadding = false,
    close,
    historyBack = false
  } = props;
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const {
    meta
  } = pageData.data;
  const css = useStyles();
  const pageTitle = title ? title : meta === null || meta === void 0 ? void 0 : meta.title;
  const history = (0, _reactRouterDom.useHistory)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)({
      [css.root]: true,
      [css.rootSaveTopAreaPadding]: saveTopAreaPadding,
      [css.fixed]: fixed
    })
  }, historyBack && checkShowHistoryBackButton() && /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    onClick: () => {
      history.goBack();
    },
    className: css.iconBack,
    src: "/img/icons/arrow-back.svg",
    size: 32
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: (0, _clsx.default)({
      [css.headline]: true,
      [css.headlineClosePadding]: close || historyBack
    }),
    variant: "h2"
  }, pageTitle), close && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: css.iconClose,
    onClick: () => {
      close();
    }
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    src: "/img/icons/close.svg",
    size: 24
  })));
};
const checkShowHistoryBackButton = () => {
  const blockURLs = ["/", "/de/", "/en/"];
  if (blockURLs.includes(window.location.pathname)) {
    return false;
  } else {
    return true;
  }
};
var _default = exports.default = PageNavigation;